import styled from 'vue-styled-components';

import { GRAY } from '@styles/common.styled';

export const LabelFilterWrapper = styled.div`
    #name {
        display: inline-block;
        margin-left: 3px;
        overflow: hidden;
        max-width: 114px;
        min-width: 114px;
        padding-right: 8px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    #dimensionGroup {
        color: ${GRAY(40)};
    }
`;
